module.exports = __webpack_public_path__ + "img/FormatBrushIcon.3faaa5c7.svg";